// initial state
const state = {
  activeRequest: false,
};

// getters
const getters = {};

// actions
const actions = {
  login({commit, state}, {username, password}) {
    // API Call
    // mutation to show loading state
    commit('activeRequest', 'loginRequest');
  },
};

// mutations
const mutations = {
  activeRequest(state) {
    state.activeRequest = !state.activeRequest;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/authentication.js